/**
 * @fileoverview Renderer for the file_tool.
 * Displays file operations with appropriate icons and text.
 */

'use client';

import { Loader2 } from 'lucide-react';
import { getFileOperationIcon, getFileOperationText } from '../../../tool-views/util';

interface FileToolRendererProps {
  /** Whether the tool is loading */
  isLoading: boolean;
  /** Input containing file operation details */
  input: {
    operation?: string;
    filePath?: string;
  };
}

/**
 * Renders the file_tool with operation-specific icon and text.
 */
export function FileToolRenderer({ isLoading, input }: FileToolRendererProps) {
  const FileIcon = getFileOperationIcon(input.filePath);

  return (
    <>
      {isLoading ? (
        <Loader2 className="size-4 animate-spin text-blue-500" />
      ) : (
        <FileIcon className="size-4 text-muted-foreground/60" />
      )}
      <span className="text-muted-foreground">
        {getFileOperationText(input.operation || '')}
      </span>
      <span className="text-xs text-muted-foreground">{input.filePath}</span>
    </>
  );
}
